import { PayloadAction } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import { all, put, takeLatest, delay, takeEvery } from "redux-saga/effects";
import history from '../../providers/history';
import { itemsObservationsListRequestService, itemsObservationsSaveRequestService, itemsObservationsRemoveRequestService } from "./services";
import { itemsObservationsListFailure, itemsObservationsListRequest, itemsObservationsListSuccess, itemsObservationsSetPagination, itemsObservationsSaveSuccess, itemsObservationsSaveFailure, itemsObservationsSaveRequest, itemObservationRemoveSuccess, itemObservationRemoveFailure, itemObservationRemoveRequest, stopEditingItemObservation } from "./slice";
import { IItemObservationFilter, IItemsObservationsResponse, IItemObservation, IItemObservationSaveRequestPayload, IItemObservationSaveRequestResponse, IItemObservationRemoveRequestResponse } from "./types";


// Liste Items Observations
function* itemsObservationsListRequestSaga(action: PayloadAction<IItemObservationFilter | undefined>) {
    try {
        const itemsObservationsListResponse: AxiosResponse<IItemsObservationsResponse> = yield itemsObservationsListRequestService(action.payload);

        if (itemsObservationsListResponse.data.status) {
            yield put(itemsObservationsListSuccess(itemsObservationsListResponse.data.data))
            yield put(itemsObservationsSetPagination({
                count: itemsObservationsListResponse.data.count,
                countFiltered: itemsObservationsListResponse.data.countFiltered
            }))
        }
        else {
            yield put(itemsObservationsListFailure({
                message: itemsObservationsListResponse.data.message || 'Error trying to get users list'
            }));
        }
    }
    catch (error: any) {
        yield put(itemsObservationsListFailure({
            message: error.response.data.message || 'Error trying to get users list'
        }));
    }
}

function* watchItemsObservationsListRequestSaga() {
    yield takeLatest(itemsObservationsListRequest.type, itemsObservationsListRequestSaga);
}

// Save Items Observations
function* itemObservationSaveRequestSaga(action: PayloadAction<IItemObservation>) {
    try {
        const payloadItemObservation: IItemObservationSaveRequestPayload = {
            observation: action.payload.observation
        }

        const itemsObservationsSaveResponse: AxiosResponse<IItemObservationSaveRequestResponse> = yield itemsObservationsSaveRequestService(payloadItemObservation, action.payload.id);

        if (itemsObservationsSaveResponse.data.status) {
            yield put(itemsObservationsSaveSuccess({
                ...action.payload,

                observation: itemsObservationsSaveResponse.data.data.observation,
                id: itemsObservationsSaveResponse.data.data.id
            }))

            yield put(stopEditingItemObservation())
            history.back();
            yield delay(50);

        }
        else {
            yield put(itemsObservationsSaveFailure({
                id: action.payload.id || "",
                error: {
                    message: itemsObservationsSaveResponse.data.message || 'Error trying to save Item Observation'
                }
            }));
        }
    }
    catch (error: any) {
        yield put(itemsObservationsSaveFailure({
            id: action.payload.id || "",
            error: {
                message: error.response.data.message || 'Error trying to get the list of items observations'
            }
        }));
    }
}

function* watchItemObservationRequestSaga() {
    yield takeLatest(itemsObservationsSaveRequest.type, itemObservationSaveRequestSaga);
}

// REMOVE ITEM OBSERVATION

function* itemsObservationsRemoveSaga(action: PayloadAction<string>) {
    try {
        const itemObservationRemoveResponse: AxiosResponse<IItemObservationRemoveRequestResponse> = yield itemsObservationsRemoveRequestService(action.payload);

        if (itemObservationRemoveResponse.data.status) {
            history.back();

            yield put(itemObservationRemoveSuccess(action.payload))
        }
        else {
            yield put(itemObservationRemoveFailure({
                itemObservationId: action.payload,
                error: {
                    message: itemObservationRemoveResponse.data.message || 'Error trying to remove this item observation'
                }
            }));
        }
    } catch (error: any) {
        yield put(itemObservationRemoveFailure({
            itemObservationId: action.payload,
            error: {
                message: error.response.data.message || 'Error trying to remove this item observation'
            }
        }));
    }
}

function* watchItemsObservationsRemoveSaga() {
    yield takeEvery(itemObservationRemoveRequest.type, itemsObservationsRemoveSaga);
}


export default all([
    watchItemsObservationsListRequestSaga(),
    watchItemObservationRequestSaga(),
    watchItemsObservationsRemoveSaga()

])